import { render, staticRenderFns } from "./file-sort.vue?vue&type=template&id=d73c4bcc&scoped=true&"
import script from "./file-sort.vue?vue&type=script&lang=js&"
export * from "./file-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73c4bcc",
  null
  
)

export default component.exports